/** Dictionnaire anglais : clé = texte français du code (voir `i18n.ts`). */
import p1 from "./i18n-en/p1";
import p2 from "./i18n-en/p2";
import p3 from "./i18n-en/p3";
import p4 from "./i18n-en/p4";
import p5 from "./i18n-en/p5";
import p6 from "./i18n-en/p6";
import p7 from "./i18n-en/p7";
import p8 from "./i18n-en/p8";
import p9 from "./i18n-en/p9";
import p10 from "./i18n-en/p10";

export const EN: Record<string, string> = { ...p1, ...p2, ...p3, ...p4, ...p5, ...p6, ...p7, ...p8, ...p9, ...p10 };
